import { Skeleton } from '@wwe-portal/ui/components/skeleton';

export const TriviaGameSkeleton = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex justify-between gap-5">
        <Skeleton className="h-[100px] w-[100px] flex-grow" />
        <Skeleton className="h-[100px] w-[100px] flex-grow" />
        <Skeleton className="h-[100px] w-[100px] flex-grow" />
        <Skeleton className="h-[100px] w-[100px] flex-grow" />
      </div>

      <div className="mt-10 flex flex-col justify-center gap-5">
        <Skeleton className="h-[50px] w-[200px]" />
        <Skeleton className="h-[50px] w-[200px]" />
      </div>
    </div>
  );
};
